<script>
import FormCadastro from '@components/FormCadastro'

export default {
  name: 'CardCadastro',
  components: { FormCadastro },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    formStyle: 'display: flex; align-items: center; justify-content: center; flex-direction: column'
  }),
  computed: {
    isMobile () {
      return this.rl.width < 467
    }
  }
}
</script>

<template>
  <div
    :class="isMobile ? 'cadastro-card mobile' : 'cadastro-card'"
    :style="{'--scale': scale}"
  >
    <div class="cadastro-card-container">
      <div
        class="cadastro-card-title"
        v-html="wl.strings['cadastro-card-title']"
      />
      <FormCadastro
        :scale="scale"
        :label-color="isMobile ? 'var(--on-primary)' : 'var(--primary)'"
        error-color="rgb(150, 0, 0)"
        :form-style="formStyle"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cadastro-card {
  background-color: var(--surface);
  border-radius: calc(6px * var(--scale));
  border: 1px solid var(--surface);
  margin: calc(15px * var(--scale));
  overflow: hidden;
  .cadastro-card-title {
    font: bold calc(24px * var(--scale))/calc(24px * var(--scale)) 'Open Sans';
    text-align: center;
    text-transform: uppercase;
    color: var(--primary);
    padding: calc(15px * var(--scale));
  }
}

.cadastro-card.mobile {
  border: none;
  background-color: transparent;
  .cadastro-card-title {
    color: var(--on-primary);
  }
}
</style>
